module.exports = __webpack_public_path__ + "static/media/sg.4ebd9325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sg.svg
// module id = 243
// module chunks = 0